import { Component } from '@angular/core';
import { Tab } from '../../models/tab.model';
import { TAB_NAMES } from 'src/app/modules/shared/models/constants';
import { GlobalStoreService } from '../../services/global-store.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-tabs',
  standalone: false,
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss']
})
export class TabsComponent {

  path: string;
  TABS: Tab[] = [
    {
      name: TAB_NAMES.GROSS_MARGIN_SUMMARY,
      path: 'tabs/gross-margin-summary'
    },
    {
      name: TAB_NAMES.EMPLOYEE_DATA,
      path: 'tabs/employee-data'
    },
    {
      name: TAB_NAMES.TARGET_REPORT,
      path: 'tabs/target-report'
    },
    {
      name: TAB_NAMES.DRIVE_ENGINEERING_PLAN,
      path: 'tabs/engineering-plan'
    },
    // {
    //   name: TAB_NAMES.DRIVE_UPDATE,
    //   path: 'tabs/drive-update'
    // },
    {
      name: TAB_NAMES.DRIVE_UPDATE_PLAN,
      path: 'tabs/drive-plan'
    }
  ];

  constructor(public globalStore: GlobalStoreService, private router:Router) {
    // if (this.globalStore.clientMaster.PIT[0].IsPIT === true)
    // this.TABS.splice(2,0, {
    //   name: TAB_NAMES.TARGET_REPORT,
    //   path: 'tabs/target-report'
    // });
    const split = this.router.url.split('/');
    const path = split[split.length - 2] + '/' + split[split.length - 1];
   // const split1 = location.href.split('/');
    //console.log(split);
    //console.log(path);
    //console.log(split1);
    //const path1 = split1[split1.length - 2] + '/' + split1[split1.length - 1];
    //console.log(path1);
    this.path = path;
  }
}
